import { types } from "mobx-state-tree";

export const AuthModel = types.model("AuthModel", {
  accessToken: types.maybe(types.string),
  accessTokenType: types.maybe(types.string),
  accessTokenExpiresIn: types.number,
  refreshToken: types.maybe(types.string),
  refreshTokenExpiresIn: types.number,
});

export const UserModel = types.model("UserModel", {
  firstName: types.maybe(types.string),
  lastName: types.maybe(types.string),
});
